/* eslint-disable complexity */
import {ChangeEvent, forwardRef, useState, useEffect, useRef} from 'react';
import classNames from 'classnames';
import PowerList from '@/components/DropMenu/clickDropMenu/index';
import Avatar from '@/components/Avatar';

import {PowerListOption} from '@/interface';
import {ShareInviteModalType, MemberType, ModalInputWidthAdd} from '@/Constant';

import Icon, {IconSize} from '@/components/Icon';
import {CloseTagSvg} from '@/icons';
import {debounce} from 'lodash-es';
import styles from './css/searchInput.module.scss';
import kuPiper from '@/middleware/kuPiper';

const INPUT_WARP_PADDING = 24;
const INPUT_FONT_SIZE = 14;

// MARKS: 输入框Sugs组件
interface Iitems {
    isDept?: any;
    groupGuid?: string | undefined;
    spaceGuid?: string | undefined;
    gid?: number | string;
    name?: string | undefined;
    rlId?: any;
    memberGuid?: string;
    rocRoleName?: string;
    roleName?: string;
    memberType?: number;
    tenantId?: string | number | undefined;
    userGuid?: string;
    email?: string;
    id?: number;
    nickname?: string;
    avatar?: string;
    department?: string;
    status?: number;
    edit?: boolean;

    // add
    randomId?: string;
    canAuth?: boolean;
    checked?: boolean;
    children?: [];
    openChildStatus?: boolean;

    // emailGroup
    emailGroupAddress?: string;
    hlEmailGroupAddress?: string;
}
interface ISugListCompProps{
    sugListData: Iitems[];
    inputChangeValue: (inputValue: string) => void;
    handelDelSug: (itemData: Iitems) => () => void;
    // getMentionsList: () => void;
    setInputs: (val: string) => void;
    placeholder?: string;
    showPowerList?: boolean;
    powerListOptions?: PowerListOption[];
    powerDisabled?: boolean;
    powerValue?: string;
    powerListClassName?: string;
    shareInviteConfig: {
        source: string;
        type: string;
        displayType: string;
    };
    onPowerChange?: (data: string) => void;
    defaultFocus?: boolean;
    backMergeModal?: (val: boolean) => void;
}
const SugListComp = forwardRef<HTMLInputElement, ISugListCompProps>((props, inputRef) => {
    const {
        sugListData,
        inputChangeValue,
        handelDelSug,
        placeholder = kuPiper.openTextSlot('shareCollaborateSearchDefault'),
        showPowerList,
        powerListOptions,
        onPowerChange,
        powerDisabled = false,
        powerValue,
        powerListClassName,
        shareInviteConfig,
        defaultFocus = true,
        backMergeModal,
        // getMentionsList,
        // setInputs,
    } = props;
    const isShare = shareInviteConfig.type === ShareInviteModalType.share;
    const isInvite = shareInviteConfig.type === ShareInviteModalType.invite;
    const isShow = shareInviteConfig.type === ShareInviteModalType.show;
    // const inputValueRef = useRef<any>(null);
    const [inputValue, setInputValue] = useState('');
    const [inputFocusStyle, setInputFocusStyle] = useState(false);
    const [powerVal, setPowerVal] = useState(powerValue || '');
    const searchInputRef = useRef<HTMLDivElement>(null);

    const searchInputWarpRef = useRef<HTMLDivElement>(null);
    const powerMenuRef = useRef<HTMLDivElement>(null);
    const [inputMaxWidth, setInputMaxWidth] = useState(0);

    const inputChange = debounce(async (ev: ChangeEvent<HTMLInputElement>) => {
        const value = ev.target.value;
        setInputValue(value);
        // UPGRADE: 暂时下掉最近列表
        // if (!value) {
        //     setInputs(value);
        //     getMentionsList();
        //     return;
        // }
        inputChangeValue(value);
    }, 300, {
        trailing: true,
    });

    // 增加退格键删除功能
    function handleKeyDown(e: React.KeyboardEvent) {
        // 输入无值再删除就删除sug
        if (e.key === 'Backspace' && sugListData.length && !inputValue) {
            handelDelSug(sugListData[sugListData.length - 1])();
        }
    }

    useEffect(() => {
        if (searchInputWarpRef.current) {

            const searchInputWarpWidth = searchInputWarpRef.current?.getBoundingClientRect().width;
            const powerMenuWarpWidth = powerMenuRef.current ? powerMenuRef.current?.getBoundingClientRect().width : 0;
            const searchInputMaxWidth = searchInputWarpWidth - powerMenuWarpWidth - INPUT_WARP_PADDING;

            setInputMaxWidth(searchInputMaxWidth > 0 ? searchInputMaxWidth : 0);
        }
    }, [powerVal, sugListData]);

    useEffect(() => {
        if (typeof inputRef !== 'function' && inputRef?.current) {

            const inputContentWidth = sugListData.length ?
                inputValue.length * INPUT_FONT_SIZE + ModalInputWidthAdd : inputMaxWidth;
            const inputValueWidth = inputContentWidth >= inputMaxWidth ? inputMaxWidth : inputContentWidth;
            inputRef.current.style.width = `${inputValueWidth}px`;
        }
    }, [inputRef, inputValue, isInvite, isShare, sugListData, inputMaxWidth]);

    useEffect(() => {
        if (typeof inputRef !== 'function' && inputRef?.current) {
            defaultFocus && inputRef.current.focus();
            setInputFocusStyle(defaultFocus);
            inputRef.current.value = '';
            setInputValue('');
        }
        searchInputRef.current?.scrollIntoView({block: 'center'});
    }, [defaultFocus, inputRef, sugListData]);

    useEffect(() => {
        setPowerVal(powerValue || '');
    }, [powerValue]);

    // 点击输入框
    function handleClickSelector(e: any) {
        // 判断点击的元素
        if (backMergeModal && isShow) {
            if (e.target.classList.contains('sugsBox')) {
                backMergeModal(true);
            }
        }
        if (typeof inputRef !== 'function' && inputRef?.current) {
            defaultFocus && inputRef?.current.focus();
            setInputFocusStyle(defaultFocus);
        }
    }

    function handleOnFocus(e: any) {
        // setInputWidth();
        if (backMergeModal) {
            backMergeModal(true);
            return;
        }
        if (typeof inputRef !== 'function' && inputRef?.current) {
            defaultFocus && inputRef?.current.focus();
            setInputFocusStyle(defaultFocus);
        }
    }

    function handleBlur() {
        setInputFocusStyle(false);
    }

    function handlePowerChange(data: any) {
        setPowerVal(data || '');
        onPowerChange && onPowerChange(data);
    }

    function handleMouseDown(e: React.MouseEvent<HTMLDivElement>) {
        e.stopPropagation();
        if (typeof inputRef !== 'function' && inputRef?.current && defaultFocus) {
            requestAnimationFrame(() => {
                inputRef.current?.focus();
            });
        }
    }
    return (
        <>
            <div
                className={
                    classNames(
                        styles.searchInputBox,
                        inputFocusStyle && styles.inputFocus
                    )
                }
                onClick={handleClickSelector}
                ref={searchInputWarpRef}
            >
                <div className={'sugsInputBox'}>
                    <div className={'sugsBox'}>
                        {
                            sugListData.map(item => {
                                return (
                                    <div key={item.randomId} className={'sugItems'}>
                                        <div
                                            className={
                                                classNames('sugItemsContent')
                                            }
                                        >
                                            {
                                                item?.isDept ?
                                                    <Avatar
                                                        className={'avatarSize'}
                                                        size="xs"
                                                        defaultText={item.name || item.nickname}
                                                        groupGuid={item.groupGuid}
                                                        spaceGuid={item.spaceGuid}
                                                    /> :
                                                    <Avatar
                                                        className={'avatarSize'}
                                                        size="xs"
                                                        userGuid={item.userGuid}
                                                        gid={item.gid}
                                                        defaultText={item.name || item.nickname}
                                                        emailGroup={item.memberType === MemberType.EmailGroup}
                                                    />
                                            }
                                            <span className={'sugText'}>
                                                {item.memberType === MemberType.EmailGroup ?
                                                    item.emailGroupAddress : item.gid ? item.name : item.nickname}
                                            </span>
                                            <span className={'closeBtn'}>
                                                <Icon
                                                    onClick={handelDelSug(item)}
                                                    size={IconSize.XXXS}
                                                    svg={CloseTagSvg}
                                                />
                                            </span>
                                        </div>
                                    </div>
                                );
                            })
                        }
                        <div className={'inputBox'} ref={searchInputRef}>
                            <input
                                className={'inputContent'}
                                type="text"
                                ref={inputRef}
                                onChange={inputChange}
                                placeholder={placeholder && sugListData.length ? '' : placeholder}
                                onKeyDown={handleKeyDown}
                                onFocus={handleOnFocus}
                                onBlur={handleBlur}
                            />
                        </div>
                    </div>

                </div>
                {
                    (!!sugListData.length) && showPowerList &&
                    <div className={'powerBox'} ref={powerMenuRef} onMouseDown={handleMouseDown}>
                        <PowerList
                            className={powerListClassName}
                            optionList={powerListOptions}
                            handleBlur={handleBlur}
                            disabled={powerDisabled}
                            value={powerVal}
                            onChange={handlePowerChange}
                        />
                    </div>
                }
            </div>
        </>
    );
});
export default SugListComp;
